import * as React from 'react';
import { useSelector } from 'react-redux';
import { CompilationHeaderLayout } from '../../components/CompilationHeaderLayout';
import { HeaderLayout } from '../../components/HeaderLayout';
import { selectIsCompilation } from '../../selectors/compilation';
import { BackButtonContainer } from '../BackButton';
import { ChipsContainer } from '../Chips';
import { CounterContainer } from '../CounterContainer';
import { FakeSearchInputContainer } from '../FakeSearchInput';
import { PageTitleAndDescriptionContainer } from '../PageTitleAndDescription';
import { SortingContainer } from '../SortingContainer';

export const HeaderContainer: React.FC = () => {
  const isCompilation = useSelector(selectIsCompilation);

  if (isCompilation) {
    return <CompilationHeaderLayout titleAndDescription={<PageTitleAndDescriptionContainer />} />;
  }

  return (
    <HeaderLayout
      backButton={<BackButtonContainer />}
      titleAndDescription={<PageTitleAndDescriptionContainer />}
      sorting={<SortingContainer />}
      fakeSearchInput={<FakeSearchInputContainer />}
      chips={<ChipsContainer />}
      counter={<CounterContainer />}
    />
  );
};
